import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestKycStatusList(params) {
  if (params === undefined) {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/kycactivity`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/kycactivity?${params}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}

/**
 *
 * @param {kycActivity status change} param0
 */
export function requestForChangeStatus(value) {
  return fetch.patch(
    `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/change-Kyc-status`,
    {
      ...value,
    }
  );
}

/**
 *
 * @param {aggrement status change} param0
 */

export function requestForAggrementChangeStatus(value){
  return fetch.patch(
    `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/change-agreement-documents-status`,{
      ...value,
    }
  )
}


/**
 * @param {smartProposal} data
 */
export function requestForAddComments(value) {
  return fetch.patch(
    `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/addcomments`,
    {
      ...value,
    }
  );
}

export function requestKYCAgreementList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/smart-proposal/smartsuiteagreement`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement?${params}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}
